import { RecentList } from './RecentList';
export { RecentList };



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/dialpad/index.js